<div class="min-h-screen overflow-x-hidden tfr-page-gradient font-sans">
  <div class="tfr-page-shell-narrow pt-10 pb-24">

    @if (loading()) {
      <div class="rounded-2xl border border-pale-gray bg-snow-white p-8 text-center">
        <lucide-icon name="loader-circle" [size]="22" class="animate-spin mx-auto text-slate-blue" />
        <p class="text-[13px] mt-2 text-steel-gray">Cargando formalización&hellip;</p>
      </div>
    } @else if (isResolvingFromSession()) {
      <section class="rounded-2xl border border-pale-gray bg-cloud-mist p-5">
        <p class="text-[14px] font-semibold text-midnight-indigo">Pago recibido. Registrando tu reserva&hellip;</p>
        <p class="mt-1 text-[13px] text-steel-gray">Espera unos segundos mientras confirmamos el pago con Stripe.</p>
      </section>
    } @else if (loadError()) {
      <div class="rounded-2xl border border-pale-gray bg-snow-white p-6 text-center">
        <p class="text-[15px] font-semibold text-midnight-indigo">No se encontró la reserva</p>
        <p class="text-[13px] mt-2 text-steel-gray">Vuelve a Mis reservas o contacta con soporte.</p>
        <button type="button" (click)="goToBookings()"
          class="mt-4 rounded-xl bg-action-blue px-5 py-2.5 text-[13px] font-semibold text-snow-white">
          Ir a Mis reservas
        </button>
      </div>
    } @else if (isConfirmed()) {
      <section class="rounded-3xl border border-platinum-tint bg-snow-white p-6 sm:p-8 shadow-tfr-sm text-center">
        <lucide-icon name="circle-check" [size]="40" class="mx-auto text-midnight-indigo" />
        <h1 class="mt-4 text-[24px] font-bold text-midnight-indigo">Reserva confirmada</h1>
        <p class="mt-2 text-[14px] leading-relaxed text-steel-gray">
          El propietario ha validado el pago. Tu reserva queda firme.
        </p>
        <button type="button" (click)="goToBookings()"
          class="mt-6 rounded-xl bg-action-blue px-5 py-3 text-[14px] font-semibold text-snow-white">
          Ver Mis reservas
        </button>
      </section>
    } @else if (submitted() || isPendingVerification()) {
      <section class="rounded-3xl border border-platinum-tint bg-snow-white p-6 sm:p-8 shadow-tfr-sm text-center">
        <lucide-icon name="circle-check" [size]="40" class="mx-auto text-midnight-indigo" />
        <h1 class="mt-4 text-[24px] font-bold text-midnight-indigo">Formalización enviada</h1>
        @if (booking()?.fastTrackBizum) {
          <p class="mt-2 text-[14px] leading-relaxed text-steel-gray">
            Has firmado el contrato e indicado que enviarás la señal ({{ depositDue() }}€) por Bizum.
            El propietario la confirmará en la app; te avisaremos cuando la reserva quede confirmada.
          </p>
        } @else {
          <p class="mt-2 text-[14px] leading-relaxed text-steel-gray">
            Has firmado el contrato y adjuntado el justificante. El propietario debe verificar el ingreso de la señal
            ({{ depositDue() }}€) antes de confirmar la reserva.
          </p>
        }
        <button type="button" (click)="goToBookings()"
          class="mt-6 rounded-xl bg-action-blue px-5 py-3 text-[14px] font-semibold text-snow-white">
          Ver Mis reservas
        </button>
      </section>
    } @else if (formalizationExpired()) {
      <section class="rounded-3xl border border-red-200 bg-red-50 p-6 sm:p-8">
        <h1 class="text-[22px] font-bold text-red-900">Plazo de formalización expirado</h1>
        <p class="mt-2 text-[14px] leading-relaxed text-red-800">
          Ha expirado el plazo de formalización ({{ formalizationPlazoSummary() }}).
          El espacio se ha liberado. La tasa online no es reembolsable según las condiciones del Paso 1.
        </p>
        <button type="button" (click)="goToBookings()"
          class="mt-5 rounded-xl border border-red-300 bg-white px-5 py-2.5 text-[13px] font-semibold text-red-900">
          Volver a Mis reservas
        </button>
      </section>
    } @else if (isPendingFormalization()) {

      @if (receiptRejected()) {
        <section class="mb-6 rounded-2xl border border-amber-300 bg-amber-50 p-4 sm:p-5">
          <p class="text-[14px] font-semibold text-amber-900">Justificante no válido</p>
          <p class="mt-1 text-[13px] leading-relaxed text-amber-800">
            El propietario no ha podido verificar tu justificante de la señal.
            @if (booking()?.depositReceiptRejectionNote) {
              Motivo: {{ booking()?.depositReceiptRejectionNote }}.
            } @else {
              Comprueba que el importe, la fecha y el destinatario coinciden con los datos del propietario.
            }
            Sube un nuevo justificante y vuelve a enviar la formalización.
          </p>
        </section>
      }

      <header class="mb-6">
        <p class="text-[10px] uppercase tracking-[0.16em] font-semibold text-steel-gray">Paso 2 · Formalizaci&oacute;n</p>
        <h1 class="mt-2 text-[26px] font-bold leading-tight text-midnight-indigo">
          @if (receiptRejected()) {
            Corrige tu justificante
          } @else {
            &iexcl;Reserva bloqueada!
          }
        </h1>
        <p class="mt-2 text-[14px] leading-relaxed text-slate-blue">
          @if (receiptRejected()) {
            La reserva sigue bloqueada. Solo necesitas subir de nuevo el justificante de la señal y confirmar el envío.
          } @else {
            Realiza la se&ntilde;al al propietario, adjunta el justificante y firma el contrato. Los tres pasos son obligatorios.
          }
        </p>
      </header>

      <!-- ── Deadline countdown banner (urgency-driven) ───────────────────────── -->
      @if (deadlineLabel()) {
        <section class="mb-6 rounded-3xl p-5 sm:p-6 shadow-tfr-sm border-2"
          [class.border-red-500]="deadlineUrgency() === 'critical'"
          [class.bg-red-50]="deadlineUrgency() === 'critical'"
          [class.border-amber-400]="deadlineUrgency() === 'warning'"
          [class.bg-amber-50]="deadlineUrgency() === 'warning'"
          [class.border-emerald-300]="deadlineUrgency() === 'safe'"
          [class.bg-emerald-50]="deadlineUrgency() === 'safe'">

          <div class="flex items-start gap-4">
            <div class="shrink-0 h-12 w-12 sm:h-14 sm:w-14 rounded-2xl flex items-center justify-center"
              [class.bg-red-500]="deadlineUrgency() === 'critical'"
              [class.bg-amber-500]="deadlineUrgency() === 'warning'"
              [class.bg-emerald-500]="deadlineUrgency() === 'safe'">
              <lucide-icon [name]="deadlineUrgency() === 'critical' ? 'alarm-clock' : 'clock-alert'"
                [size]="24" class="text-white" />
            </div>
            <div class="min-w-0 flex-1">
              <p class="text-[10px] uppercase tracking-[0.16em] font-semibold"
                [class.text-red-700]="deadlineUrgency() === 'critical'"
                [class.text-amber-700]="deadlineUrgency() === 'warning'"
                [class.text-emerald-700]="deadlineUrgency() === 'safe'">
                Plazo para completar la formalizaci&oacute;n
              </p>
              <p class="mt-1 text-[28px] sm:text-[32px] font-bold leading-none tabular-nums"
                [class.text-red-900]="deadlineUrgency() === 'critical'"
                [class.text-amber-900]="deadlineUrgency() === 'warning'"
                [class.text-emerald-900]="deadlineUrgency() === 'safe'">
                {{ deadlineCountdown() }}
              </p>
              <p class="mt-2 text-[12px] sm:text-[13px] leading-snug"
                [class.text-red-800]="deadlineUrgency() === 'critical'"
                [class.text-amber-800]="deadlineUrgency() === 'warning'"
                [class.text-emerald-800]="deadlineUrgency() === 'safe'">
                Hasta el <strong>{{ deadlineLabel() }}</strong>
                &middot; ventana de {{ formalizationPlazoSummary() }}
              </p>
              @if (deadlineUrgency() === 'critical') {
                <p class="mt-2 text-[12px] font-semibold text-red-900">
                  Si no completas a tiempo, la reserva se cancela y la tasa de gesti&oacute;n no es reembolsable.
                </p>
              }
            </div>
          </div>
        </section>
      }

      <!-- ── Booking summary card ─────────────────────────────────────────────── -->
      <section class="rounded-3xl border border-platinum-tint bg-snow-white p-5 sm:p-6 shadow-tfr-sm mb-6">
        <div class="flex items-start gap-3 mb-4">
          <div class="shrink-0 h-9 w-9 rounded-lg flex items-center justify-center bg-pale-gray">
            <lucide-icon name="calendar-check-2" [size]="18" class="text-action-blue" />
          </div>
          <div class="min-w-0 flex-1">
            <h2 class="text-[14px] font-bold text-midnight-indigo">Detalles de tu reserva</h2>
            <p class="text-[11px] text-steel-gray">Confirmaci&oacute;n de los datos del Paso 1.</p>
          </div>
        </div>

        @if (booking()?.spaceName; as spaceName) {
          <p class="text-[16px] sm:text-[18px] font-bold text-midnight-indigo mb-3">{{ spaceName }}</p>
        }

        <dl class="grid grid-cols-1 sm:grid-cols-2 gap-3 text-[12px]">
          @if (bookingDateLabel()) {
            <div class="rounded-xl bg-cloud-mist px-3 py-2.5">
              <dt class="text-[10px] uppercase tracking-wider font-semibold text-steel-gray">Fecha</dt>
              <dd class="mt-0.5 text-[13px] font-semibold text-midnight-indigo first-letter:uppercase">
                {{ bookingDateLabel() }}
              </dd>
            </div>
          }
          @if (bookingHoursLabel()) {
            <div class="rounded-xl bg-cloud-mist px-3 py-2.5">
              <dt class="text-[10px] uppercase tracking-wider font-semibold text-steel-gray">Horario</dt>
              <dd class="mt-0.5 text-[13px] font-semibold text-midnight-indigo tabular-nums">
                {{ bookingHoursLabel() }}
              </dd>
            </div>
          }
        </dl>

        <div class="mt-4 pt-4 border-t border-pale-gray">
          <p class="text-[10px] uppercase tracking-wider font-semibold text-steel-gray mb-2">Desglose</p>
          <dl class="space-y-1.5 text-[13px]">
            <div class="flex items-center justify-between gap-3">
              <dt class="text-slate-blue">Tasa de gesti&oacute;n online (pagada)</dt>
              <dd class="font-semibold tabular-nums text-midnight-indigo line-through opacity-60">
                {{ commissionPaid() }}&nbsp;&euro;
              </dd>
            </div>
            <div class="flex items-center justify-between gap-3">
              <dt class="text-slate-blue">Se&ntilde;al pendiente al propietario</dt>
              <dd class="font-semibold tabular-nums text-midnight-indigo">
                {{ depositDue() }}&nbsp;&euro;
              </dd>
            </div>
            <div class="flex items-center justify-between gap-3 pt-2 border-t border-pale-gray">
              <dt class="text-[12px] uppercase tracking-wider font-semibold text-steel-gray">Total</dt>
              <dd class="text-[16px] font-bold tabular-nums text-midnight-indigo">
                {{ totalAmount() }}&nbsp;&euro;
              </dd>
            </div>
          </dl>
        </div>
      </section>

      @if (isFullPayment()) {
        <section class="rounded-3xl border border-emerald-200 bg-emerald-50 p-5 sm:p-6 shadow-tfr-sm mb-6">
          <h2 class="text-[14px] font-bold text-emerald-900">Alquiler pagado con tarjeta</h2>
          <p class="mt-1 text-[12px] text-emerald-800 leading-relaxed">
            El importe del alquiler ya est&aacute; cobrado de forma segura. Solo debes firmar el contrato.
            La fianza (si aplica) se gestionar&aacute; desde 48&nbsp;h antes del evento.
          </p>
        </section>
      }

      @if (!isFullPayment()) {
      <section id="tfr-step-deposit" class="rounded-3xl border border-platinum-tint bg-snow-white p-5 sm:p-6 shadow-tfr-sm mb-6 scroll-mt-24">
        <h2 class="text-[14px] font-bold text-midnight-indigo">Pago de la señal al propietario</h2>
        <p class="mt-1 text-[12px] text-steel-gray">
          Importe pendiente tras la tasa de gestión online: <strong class="text-midnight-indigo">{{ depositDue() }}€</strong>.
          M&eacute;todos aceptados por el propietario:
        </p>

        @if (ownerPaymentReady()) {
          <div class="mt-4 space-y-3">
            @if (ownerSettings()?.sepaEnabled && ownerSettings()?.iban) {
              <dl class="rounded-2xl border border-pale-gray bg-cloud-mist p-4 space-y-3">
                <p class="text-[11px] font-semibold uppercase tracking-wider text-steel-gray">
                  Transferencia (SEPA)
                </p>
                <div class="flex justify-between gap-3">
                  <dt class="text-[11px] font-semibold uppercase text-steel-gray">Titular</dt>
                  <dd class="text-[13px] font-semibold text-right text-midnight-indigo">{{ ownerSettings()?.accountHolder }}</dd>
                </div>
                <div class="flex justify-between gap-3">
                  <dt class="text-[11px] font-semibold uppercase text-steel-gray">IBAN</dt>
                  <dd class="font-mono text-[13px] font-semibold text-right break-all text-midnight-indigo">
                    {{ formatIban(ownerSettings()?.iban) }}
                  </dd>
                </div>
              </dl>
            }

            @if (ownerSettings()?.bizumEnabled && ownerSettings()?.mobilePhone) {
              <dl class="rounded-2xl border border-pale-gray bg-cloud-mist p-4 space-y-3">
                <p class="text-[11px] font-semibold uppercase tracking-wider text-steel-gray">
                  Bizum
                </p>
                <div class="flex justify-between gap-3">
                  <dt class="text-[11px] font-semibold uppercase text-steel-gray">M&oacute;vil</dt>
                  <dd class="text-[13px] font-semibold tabular-nums text-midnight-indigo">{{ ownerSettings()?.mobilePhone }}</dd>
                </div>
              </dl>
            }

            @if (ownerSettings()?.cashEnabled) {
              <div class="rounded-2xl border border-pale-gray bg-cloud-mist p-4 space-y-2">
                <p class="text-[11px] font-semibold uppercase tracking-wider text-steel-gray">
                  Efectivo
                </p>
                <p class="text-[13px] text-midnight-indigo">
                  El propietario acepta el pago en efectivo en el local el d&iacute;a del evento.
                </p>
                <p class="text-[11px] leading-relaxed text-steel-gray">
                  Si eliges esta opci&oacute;n, acuerda los detalles con el propietario y aporta un recibo o justificante firmado al subirlo m&aacute;s abajo.
                </p>
              </div>
            }
          </div>
          <p class="mt-3 text-[11px] leading-relaxed text-steel-gray">
            Elige el m&eacute;todo que prefieras y conserva el justificante para subirlo abajo. El titular o destinatario del pago debe coincidir con los datos mostrados.
          </p>
        } @else {
          <p class="mt-4 rounded-xl border border-amber-200 bg-amber-50 px-3 py-2.5 text-[12px] text-amber-900">
            El propietario a&uacute;n no ha activado ning&uacute;n m&eacute;todo de cobro en sus ajustes.
            No podr&aacute;s enviar la formalizaci&oacute;n hasta que lo configure.
          </p>
        }
      </section>
      }

      <form [formGroup]="form" (ngSubmit)="submitFormalization()" class="flex flex-col gap-6">

        @if (!isFullPayment()) {
        <section id="tfr-step-receipt" class="rounded-3xl border border-platinum-tint bg-snow-white p-5 sm:p-6 shadow-tfr-sm scroll-mt-24">
          <h2 class="text-[14px] font-bold text-midnight-indigo">Justificante de pago</h2>
          @if (fastTrackEligible()) {
            <p class="mt-1 text-[12px] text-steel-gray">
              Reserva urgente: puedes enviar la señal por Bizum y formalizar sin justificante, o subir el comprobante.
            </p>
            <label class="mt-4 flex items-start gap-3 cursor-pointer select-none rounded-2xl border border-amber-200 bg-amber-50 p-4">
              <input type="checkbox"
                class="mt-0.5 h-4 w-4 rounded border-pale-gray text-action-blue focus:ring-action-blue/30"
                [checked]="fastTrackBizum()"
                (change)="onFastTrackToggle($any($event.target).checked)" />
              <span class="text-[12px] leading-snug text-amber-900">
                <strong>Enviaré la señal por Bizum ahora</strong> y no puedo subir el justificante a tiempo.
                El propietario confirmará el pago por teléfono o en la app.
              </span>
            </label>
          } @else {
            <p class="mt-1 text-[12px] text-steel-gray">Tras transferir o enviar Bizum, sube el PDF o la captura de la señal (obligatorio).</p>
          }

          @if (!fastTrackBizum()) {
          <input #receiptInput type="file" accept=".pdf,image/*" class="hidden" (change)="onReceiptSelected($event)" />

          <button type="button"
            class="mt-4 w-full rounded-2xl border-2 border-dashed p-6 text-center transition-colors"
            [class.border-platinum-tint]="!isDropOver()"
            [class.bg-cloud-mist]="!isDropOver()"
            [class.border-midnight-indigo]="isDropOver()"
            (click)="triggerReceiptInput(receiptInput)"
            (dragover)="onReceiptDragOver($event)"
            (dragleave)="onReceiptDragLeave($event)"
            (drop)="onReceiptDrop($event)">
            <lucide-icon name="cloud-upload" [size]="22" class="mx-auto text-slate-blue" />
            <p class="mt-2 text-[13px] font-medium text-midnight-indigo">Arrastra el archivo o haz clic para seleccionarlo</p>
            <p class="mt-1 text-[11px] text-steel-gray">PDF, JPG, PNG o WEBP · máx. 10 MB</p>
            @if (receiptFileName()) {
              <p class="mt-3 inline-flex rounded-full bg-cloud-mist px-3 py-1 text-[12px] font-medium text-midnight-indigo">
                {{ receiptFileName() }}
              </p>
            }
          </button>
          }
        </section>
        }

        <section class="rounded-3xl border border-platinum-tint bg-snow-white p-5 sm:p-6 shadow-tfr-sm">
          <h2 class="text-[14px] font-bold text-midnight-indigo">Tus datos legales</h2>
          <div class="mt-4 grid grid-cols-1 sm:grid-cols-2 gap-4">
            <label class="block sm:col-span-2">
              <span class="text-[11px] font-semibold uppercase tracking-wide text-steel-gray">Nombre legal completo</span>
              <input type="text" formControlName="userLegalName" autocomplete="name"
                class="mt-1.5 w-full rounded-xl border border-pale-gray bg-cloud-mist px-3 py-2.5 text-[14px] text-midnight-indigo focus:outline-none focus:ring-2 focus:ring-action-blue/20" />
              @if (showError('userLegalName')) {
                <p class="mt-1 text-[11px] text-red-600">Mínimo 5 caracteres (nombre y apellidos).</p>
              }
            </label>
            <label class="block">
              <span class="text-[11px] font-semibold uppercase tracking-wide text-steel-gray">DNI / NIE / Pasaporte</span>
              <input type="text" formControlName="userDni" autocomplete="off"
                class="mt-1.5 w-full rounded-xl border border-pale-gray bg-cloud-mist px-3 py-2.5 text-[14px] uppercase text-midnight-indigo focus:outline-none focus:ring-2 focus:ring-action-blue/20" />
              @if (showError('userDni')) {
                <p class="mt-1 text-[11px] text-red-600">Formato DNI/NIE o pasaporte no válido.</p>
              }
            </label>
            <label class="block">
              <span class="text-[11px] font-semibold uppercase tracking-wide text-steel-gray">Teléfono móvil</span>
              <input type="tel" formControlName="userPhone" autocomplete="tel"
                placeholder="612345678"
                class="mt-1.5 w-full rounded-xl border border-pale-gray bg-cloud-mist px-3 py-2.5 text-[14px] tabular-nums text-midnight-indigo focus:outline-none focus:ring-2 focus:ring-action-blue/20" />
              @if (showError('userPhone')) {
                <p class="mt-1 text-[11px] text-red-600">Móvil español (9 dígitos, empieza por 6 o 7).</p>
              }
            </label>
          </div>
        </section>

        <section id="tfr-step-contract" class="rounded-3xl border border-platinum-tint bg-snow-white p-5 sm:p-6 shadow-tfr-sm scroll-mt-24">
          <h2 class="text-[14px] font-bold text-midnight-indigo">Contrato de Arrendamiento Unificado</h2>
          <p class="mt-1 text-[12px] text-steel-gray">Cláusulas base + anexo del espacio (solo lectura).</p>

          @if (contractHtmlSafe(); as html) {
            <div
              class="mt-4 max-h-64 overflow-y-auto border border-pale-gray p-4 bg-cloud-mist text-xs text-midnight-indigo font-serif prose prose-sm max-w-none"
              [innerHTML]="html">
            </div>
          }

          <label class="mt-4 flex items-start gap-3 cursor-pointer select-none">
            <input type="checkbox"
              class="mt-0.5 h-4 w-4 rounded border-pale-gray text-action-blue focus:ring-action-blue/30"
              [checked]="contractAccepted()"
              (change)="contractAccepted.set($any($event.target).checked)" />
            <span class="text-[12px] font-bold leading-snug text-midnight-indigo">
              He leído el contrato y acepto firmarlo digitalmente con los datos indicados arriba.
            </span>
          </label>
        </section>

        @if (submitError(); as err) {
          <p class="text-[12px] text-red-600 text-center">{{ err }}</p>
        }

        <button type="submit"
          [disabled]="!canSubmit()"
          class="w-full py-3.5 rounded-2xl text-[15px] font-semibold text-snow-white bg-action-blue
                 disabled:opacity-40 disabled:cursor-not-allowed shadow-tfr-sm hover:brightness-110">
          @if (submitting()) {
            Enviando formalización&hellip;
          } @else if (fastTrackBizum()) {
            Enviar sin justificante y firmar contrato
          } @else {
            Enviar justificante y firmar contrato
          }
        </button>

        @if (!canSubmit() && !submitting()) {
          <p class="text-[11px] text-center text-steel-gray">
            @if (fastTrackEligible() && !fastTrackBizum() && !receiptFile()) {
              Adjunta el justificante o marca la opción Bizum urgente, completa tus datos y acepta el contrato.
            } @else {
              Adjunta el justificante (o usa Bizum urgente), completa tus datos, acepta el contrato y verifica que el propietario tenga cobros activos.
            }
          </p>
        }
      </form>

    }
  </div>
</div>
